import React, { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import {
  useGetMenusDataQuery,
  useGetFooterMenusDataQuery,
} from "../../redux/services/internal/apiHome";
import MenuPage from "../../Frontend/Container/pages/MenuPage";
import Spinner from "../../Frontend/Container/Components/Spinner";
import { flattenMenus } from "../../Utility/FlattenMenu";
import PhotoGallery from "../../Frontend/Container/pages/GalleryPages/PhotoGallery";
import MinisterDetailPage from "../../Frontend/Container/pages/Home/MinisterDetailPage";
import WhatsNewDetail from "../../Frontend/Container/pages/WhatsNewDetail";
import FooterTopCategory from "../../Frontend/Container/pages/FooterTopCategory";
import FooterNavPage from "../../Frontend/Container/pages/FooterNavPages/FooterNavPage";
import FooterMenuPage from "../../Frontend/Container/pages/FooterMenuPage";
import CourtLinkPages from "../../Frontend/Container/pages/CourtLinkPages";
import CalendarPage from "../../Frontend/Container/pages/CalendarPage";
import PresentMembersPage from "../../Frontend/Container/pages/PresentMembers/PresentMembersPage";
import MainMenuRoutes from "../../Frontend/Shared/Routes/MainMenuRoutes";
import HomeKolkata from "./ContainerKolkata/PagesKolkata/HomeKolkata";
import CmsMenuRoutes from "../../Frontend/Shared/Routes/CmsMenuRoutes";
import ScreenReader from "../../Frontend/Container/pages/ScreenReader";

function KolkataRouting({ benchId, benchName }) {
  const { data: fetchMenus = {}, isLoading } = useGetMenusDataQuery(benchId);

  const transformedData = useMemo(() => {
    return fetchMenus.data ? flattenMenus(fetchMenus.data) : [];
  }, [fetchMenus.data]);

  const { data: fetchFooterMenus = {} } = useGetFooterMenusDataQuery(7);

  const transformedDataFooter = useMemo(() => {
    return fetchFooterMenus.data ? flattenMenus(fetchFooterMenus.data) : [];
  }, [fetchFooterMenus.data]);

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <>
      <MainMenuRoutes benchId={7} />
      <CmsMenuRoutes benchId={benchId} />
      <Routes>
        <Route
          path=""
          element={<HomeKolkata benchId={benchId} benchName={benchName} />}
        ></Route>
        {/* Main Menu */}

        {transformedData?.map((item, index) => (
          <Route
            key={index}
            path={`${item.slug}`}
            element={<MenuPage benchId={benchId} />}
          ></Route>
        ))}

        {transformedDataFooter?.map((item, index) => (
          <Route
            key={index}
            path={item.slug}
            element={<FooterMenuPage benchId={benchId} />}
          ></Route>
        ))}

        <Route path="court-links" element={<CourtLinkPages />} />
        <Route
          path="photos-gallery"
          element={<PhotoGallery benchId={benchId} />}
        />
        <Route
          path="whats-new"
          element={<WhatsNewDetail benchId={benchId} />}
        ></Route>

        <Route
          path="tenders"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={1}
              pageTitle="Tender / Notices"
            />
          }
        />
        <Route
          path="policies"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={2}
              pageTitle="Policies / Circulars"
            />
          }
        />
        <Route
          path="misc-docs"
          element={
            <FooterNavPage
              benchId={benchId}
              menuPageId={3}
              pageTitle=" Miscellaneous Documents / Letters"
            />
          }
        />

        <Route
          path="vacancies"
          element={
            <FooterTopCategory
              benchId={benchId}
              pageTitle={"Vacancy"}
              apicategory={"vacancies"}
            />
          }
        />
        <Route
          path="minister-detail-page"
          element={<MinisterDetailPage benchId={benchId} />}
        />
        <Route
          path="calendar-detail"
          element={<CalendarPage benchId={benchId} />}
        />
        <Route
          path="present-members"
          element={<PresentMembersPage benchId={benchId} />}
        />
        <Route
          path="screenreader"
          element={<ScreenReader benchId={benchId} />}
        />
      </Routes>
    </>
  );
}

export default KolkataRouting;
